
import { useState, ChangeEvent } from 'react';
import {FieldExtensionComponentProps} from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import {InputAdornment} from "@material-ui/core";

export const PrefixedInputField = ({
                                       schema,
                                       onChange,
                                       rawErrors,
                                       required,
                                       formData,
                                   }: FieldExtensionComponentProps<string>) => {
    const prefix = `${schema.prefix}-`;
    const [inputValue, setInputValue] = useState(() =>
        formData?.startsWith(prefix) ? formData.slice(prefix.length) : formData || ''
    );

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value.trim();
        setInputValue(raw);
        onChange(`${prefix}${raw}`);
    };

    return (
        <FormControl
            margin="normal"
            required={required}
            error={rawErrors?.length > 0 && !formData}>
            <InputLabel htmlFor="prefixed-input">{schema?.title}</InputLabel>
            <Input
                id="prefixed-input"
                aria-describedby="prefixed-helper-text"
                value={inputValue}
                onChange={handleChange}
                startAdornment={
                    <InputAdornment
                        position="start"
                        disableTypography
                        style={{marginRight: "-2px"}}>
                        <span style={{paddingRight: 2}}>{prefix}</span>
                    </InputAdornment>
                }
            />
            <FormHelperText id="prefixed-helper-text">
                {schema?.description}
            </FormHelperText>
        </FormControl>
    );
};
